export default __webpack_public_path__ + "static/splash-1-92e22789f319e37d3849030de7380036.png";